import { useNavigate } from 'react-router-dom';

import type { RBACGroup } from '../../../types';

import ACLAutocomplete from './ACLAutocomplete';

type Props = {
  acls: RBACGroup[] | undefined;
  selectedId?: string;
};

export default function ACLSelect({ acls, selectedId }: Props) {
  const navigate = useNavigate();

  const handleSelect = (acl: RBACGroup) => {
    navigate(`/acls/${acl.id}`);
  };

  if (!acls) {
    return <div>No ACL groups to display</div>;
  }

  return (
    <div>
      <div className="font-bold pb-2">Search for ACL group:</div>
      <ACLAutocomplete
        items={acls}
        onSelect={handleSelect}
        selectedId={selectedId}
        onClear={() => navigate('/acls')}
      />
    </div>
  );
}
